module.exports = __webpack_public_path__ + "img/home_logo.5a633a87.png";